// :cow: Cosmose CONFIDENTIAL :iso:
import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { TextAnimationDirective } from './directives/text-animation.directive';


@NgModule({
  declarations: [
    TextAnimationDirective,
  ],
  imports: [
    CommonModule,
  ],
  exports: [
    TextAnimationDirective,
  ],
})
export class TextAnimationModule {
}
